import { Component, OnInit, OnDestroy, Renderer2, Input } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { MenuItem } from 'primeng/primeng';
import { Router } from '@angular/router';
import { RegistrationService } from '../services/registration.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Interviewcall } from './interviewcall';

@Component({
	selector: 'app-ineterviewcall',
	templateUrl: './ineterviewcall.component.html',
	styleUrls: ['./ineterviewcall.component.scss']
})
export class IneterviewcallComponent implements OnInit {
	msgs: Message[] = [];
	user_id: any;
	designationId: any;
	postcategoryid: any;
	departmentId: any;
	processbar: boolean = false;
	datetimeForm: boolean = false;
	public postcategoryList = [];
	public departList = [];
	public postlist = [];
	dataList: any;
	tableData: Interviewcall[];
	minDateOfBirth: Date;
	maxDateOfBirth: Date;
	dateOfBirth: Date;
	maxDateOfBirthYear: number;
	minDateOfBirthYear: number;
	candidateId: any;
	demointerviewDate: any;
	setinterviewDate: any;
	demointerviewTime: any;
	interviewcallInfoArray = [];
	interviewcallInfo: any;
	setalldttm: any;
	setallsms:any;
	showbtn: boolean = false;
	advid:any;
	departmentFlag:boolean = false;
	did:any;
	constructor(private registrationService: RegistrationService, private router: Router) { }

	ngOnInit() {
		this.user_id = localStorage.getItem('member-id');
		this.designationId = 0;
		this.postcategoryid = 0;
		this.departmentId = 0;

		const TODAY = new Date();
		const MONTH = TODAY.getMonth();
		const YEAR = TODAY.getFullYear();

		this.maxDateOfBirthYear = YEAR;
		this.minDateOfBirthYear = YEAR - 60;

		this.minDateOfBirth = new Date();
		this.minDateOfBirth.setMonth(MONTH);
		this.minDateOfBirth.setFullYear(this.minDateOfBirthYear);

		this.maxDateOfBirth = new Date();
		this.maxDateOfBirth.setMonth(MONTH);
		this.maxDateOfBirth.setFullYear(this.maxDateOfBirthYear);
		this.advid=localStorage.getItem('advId');
		this.getAllCommonList();
	}
	getAllCommonList() {
		this.processbar = true;
		this.registrationService.getCommonList(this.advid).then(res => {
			//console.log(res);
			this.dataList = res;
			this.postcategoryList = this.dataList.postcategoryList;
			if(this.advid!=5)
				this.departList = this.dataList.departList;
				//add by JD
				if (this.dataList.chkdept == 1) 
				this.departmentFlag = true;
				//end by JD
			this.postlist = this.dataList.postlist;
			this.processbar = false;
		});
	}
	loadCandidateList() {
		this.tableData = [];
		this.setalldttm = false;
		if (this.designationId == 0) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
			return false;
		}
		if (this.postcategoryid == 0) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
			return false;
		}
		// if (this.advid != 5) {
		// 	if (this.departmentId == 0) {
		// 		this.msgs = [];
		// 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
		// 		return false;
		// 	}
		// }
		       //   Add by JD
		if(this.departmentFlag == false){ 
            this.did = 0;
			this.departmentFlag = false;
        }else{
            this.did = this.departmentId;
			this.departmentFlag = true;
        }
			// end by JD
        this.processbar = true;
       // alert(this.advid);
		this.registrationService.loadCandidateList(this.did, this.postcategoryid, this.designationId,this.advid).then(res => {
			// console.log(res);
			this.dataList = res;
			if (this.dataList.msg == "success") {
				//this.dataList.candidateListdtls.interviewdate =
				this.tableData = this.dataList.candidateListdtls;
				this.showbtn = true;
			}
			else {
				alert('Data not found');
				this.tableData = [];
			}
		}).catch(this.handleError);
		this.processbar = false;

	}
	private handleError(error: any): Promise<any> {
		console.error('An error occurred', error);
		alert('An error occurred');
		return Promise.reject(error.message || error);
	}

	setdateTimeprint(id) {
		const d = new Date(Date.parse(this.demointerviewDate));
		this.setinterviewDate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
		if (this.tableData[id].chkprint && this.tableData[id].interviewchk == '0') {
			if (this.demointerviewTime == undefined) {
				this.tableData[id].interviewtime = this.tableData[id].interviewtime;
				const d = new Date(Date.parse(this.tableData[id].interviewdate));
				this.tableData[id].interviewdate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
			} else {
				this.tableData[id].interviewtime = this.demointerviewTime;
				this.tableData[id].interviewdate = this.setinterviewDate;
			}
		}
		else if (this.tableData[id].interviewchk == '0') {
			this.tableData[id].interviewdate = '';
			this.tableData[id].interviewtime = '';
		}
	}
	saveinterviewdate() {
		let chk = 0;
		for (let i = 0; i < this.tableData.length; i++) {
			if (this.tableData[i].chkprint) {
				chk = 1;
				break;
			}
		}
		if (chk) {
			for (let i = 0; i < this.tableData.length; i++) {
				this.processbar = true;
				if (this.tableData[i].interviewdate == null || this.tableData[i].interviewdate == '-') {
					this.tableData[i].interviewdate = 'NaN/NaN/NaN'
				}
				else{
					if(this.tableData[i].interviewdate.length == undefined){
						const d = new Date(Date.parse(this.tableData[i].interviewdate));
						this.tableData[i].interviewdate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
					}
				}
				if (this.tableData[i].chkprint) {
					const data = {
						cid: this.tableData[i].id,
						date: this.tableData[i].interviewdate,
						time: this.tableData[i].interviewtime
					};
					this.interviewcallInfoArray.push(data);
				}
			}
			this.interviewcallInfo = {
				"interviewcallInfo": this.interviewcallInfoArray
			};
			// console.log(this.interviewcallInfo);
			this.registrationService.saveinterviewdate(this.interviewcallInfo,this.advid).then(res => {
				this.dataList = res;
				if (this.dataList.status == 'success') {
					alert("Successfully saved");
					this.processbar = false;
				} else if (this.dataList.status == 'delete') {
					alert("Successfully updated");
					this.processbar = false;
				}
				this.interviewcallInfoArray = [];
				this.loadCandidateList();
			}).catch(this.handleError);
			//this.processbar = false;
		}
		else {
			alert("Please Select At Least One Row.");
			return false;
		}
	}

	printinterviewdate() {
		let chk = 0;
		for (let i = 0; i < this.tableData.length; i++) {
			if (this.tableData[i].chkprint) {
				chk = 1;
				break;
			}
		}
		if (chk) {
			for (let i = 0; i < this.tableData.length; i++) {
				this.processbar = true;
				if (this.tableData[i].interviewdate == null || this.tableData[i].interviewdate == '-') {
					this.tableData[i].interviewdate = 'NaN/NaN/NaN'
				}
				else{
					if(this.tableData[i].interviewdate.length == undefined){
						const d = new Date(Date.parse(this.tableData[i].interviewdate));
						this.tableData[i].interviewdate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
					}
				}
				if (this.tableData[i].chkprint && this.tableData[i].interviewdate != 'NaN/NaN/NaN') {
					const data = {
						cid: this.tableData[i].id,
						date: this.tableData[i].interviewdate,
						time: this.tableData[i].interviewtime
					};
					this.interviewcallInfoArray.push(data);
				}
			}
			this.interviewcallInfo = {
				"interviewcallInfo": this.interviewcallInfoArray
			};
			//console.log(this.interviewcallInfo);
			this.registrationService.saveinterviewdate(this.interviewcallInfo,this.advid).then(res => {
				this.dataList = res;
				if (this.dataList.status == 'success') {
					window.open(this.dataList.interviewCallLetter);
				}
				this.interviewcallInfoArray = [];
				this.loadCandidateList();
				this.processbar = false;
			}).catch(this.handleError);
		}
		else {
			alert("Please Select At Least One Row.");
			return false;
		}
	}
	setAlldateTime() {
		if (this.setalldttm) {
			for (let i = 0; i < this.tableData.length; i++) {
				if (this.demointerviewDate != undefined && this.demointerviewTime != undefined) {
					// console.log(this.tableData[i].interviewdate);
					if (this.tableData[i].interviewdate == null) {
						const d = new Date(Date.parse(this.demointerviewDate));
						this.tableData[i].interviewdate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
						this.tableData[i].interviewtime = this.demointerviewTime;
						this.tableData[i].chkprint = true;
					}
					else if (this.tableData[i].interviewdate != null) {
						this.tableData[i].chkprint = true;
					}
				}
				else if (this.tableData[i].interviewdate != null) {
					this.tableData[i].chkprint = true;
				}
			}
		} else {
			for (let i = 0; i < this.tableData.length; i++) {
				if (this.tableData[i].interviewdate != '-' || this.tableData[i].interviewdate != null) {
					this.tableData[i].chkprint = false;
				}
			}
		}
	}
	setAllSmsCheck(){
		if (this.setallsms) {
			for (let i = 0; i < this.tableData.length; i++) {
				if (this.tableData[i].interviewchk == '1' && this.tableData[i].smssendchk != '1') {
					this.tableData[i].chksms = true;
				}
			}
		} else {
			for (let i = 0; i < this.tableData.length; i++) {
				if (this.tableData[i].interviewchk  == '1' && this.tableData[i].smssendchk != '1') {
					this.tableData[i].chksms = false;
				}
			}
		}
	}
	sendSMSforInterview(){
        let chk = 0;
		for (let i = 0; i < this.tableData.length; i++) {
			if (this.tableData[i].chksms  == '1' && this.tableData[i].interviewchk  == '1') {
				chk = 1;
				break;
			}
        }
		if (chk) {
			if (confirm("Do you want to Confirm to Send SMS?")) {
				for (let i = 0; i < this.tableData.length; i++) {
					this.processbar = true;
					if (this.tableData[i].chksms == '1' && this.tableData[i].interviewchk == '1') {
						const data = {
							cid: this.tableData[i].id,
							date: this.tableData[i].interviewdate,
							time: this.tableData[i].interviewtime
						};
						this.interviewcallInfoArray.push(data);
					}
				}
				this.interviewcallInfo = {
					"interviewcallInfo": this.interviewcallInfoArray
				};
				//console.log(this.interviewcallInfo);
				this.registrationService.sendSmsForInterview(this.interviewcallInfo,this.advid).then(res => {
					this.dataList = res;
					if (this.dataList.status == 'success') {
						alert(this.dataList.msg);
					}
					this.interviewcallInfoArray = [];
					this.loadCandidateList();
					this.processbar = false;
				}).catch(this.handleError);
			}
		}
		else {
			alert("Please Select at Least One eligible candidate\n for Send SMS.");
			return false;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/ineterviewcall/ineterviewcall.component.ts